import React from "react";

const Footer = () => {
  return (
    <div className="footer-wrapper font-satoshi">
      {/* Bloc principal */}
      <footer className="relative bg-neutral-900 text-white">
        {/* Liseré dégradé haut */}
        <div className="h-1 w-full bg-gradient-to-r from-blue-500 via-indigo-500 to-sky-400" />

        <div className="mx-auto max-w-7xl px-6 py-12 lg:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 items-center gap-10">
            {/* Col gauche : Photo + signature */}
            <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
              <div className="relative">
                <img
                  src="/img/LV.webp1743073469278.webp"
                  alt="Laurent Victorin"
                  loading="lazy"
                  className="h-28 w-28 md:h-32 md:w-32 rounded-full object-cover ring-4 ring-white/10 shadow-2xl"
                />
                <span className="absolute -bottom-2 -right-2 bg-blue-500 text-xs px-2 py-1 rounded-md shadow">
                  🥋 Développeur Web
                </span>
              </div>

              <p className="mt-4 text-sm text-white/80">
                Laurent Victorin – MonAppliClub
              </p>

              {/* Bouton VKard */}
              <div className="mt-3">
                <a
                  href="https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-xs rounded-md px-3 py-1.5 ring-1 ring-white/15 bg-white/5 hover:bg-white/80 transition"
                  aria-label="Carte de visite VKard de Laurent Victorin"
                >
                  {/* petite icône carte */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3.5 w-3.5"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M3 6.75A1.75 1.75 0 0 1 4.75 5h14.5A1.75 1.75 0 0 1 21 6.75v10.5A1.75 1.75 0 0 1 19.25 19H4.75A1.75 1.75 0 0 1 3 17.25V6.75Zm2 .25v10h14V7H5Zm3.25 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm3.25 6.25h6.5v-1.5h-6.5v1.5Zm0-3h6.5v-1.5h-6.5v1.5Z" />
                  </svg>
                  <span>VKard</span>
                </a>
              </div>
            </div>

            {/* Col centre : Titre */}
            <div className="text-center">
              <h2 className="font-titre text-3xl md:text-4xl font-extrabold tracking-tight">
                <span className="block text-blueprimarylight">
                  Application Ligue
                </span>
                <span className="block text-red-600 text-2xl md:text-3xl mt-1">
                  Nouvelle Aquitaine{" "}
                  <span className="italic text-red-400"></span>
                </span>
              </h2>
              <p className="mt-4 text-white/70 max-w-xl mx-auto">
                Une plateforme pensée pour la Ligue et ses clubs : simple,
                moderne, efficace.
              </p>
            </div>

            {/* Col droite : CTA unique */}
            <div className="flex justify-center lg:justify-end">
              <a
                href="https://www.monappliclub.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-2xl px-5 py-3 ring-1 ring-white/15 bg-white/5 hover:bg-white/80  transition"
                aria-label="Découvrir toutes mes applications sur MonAppliClub"
              >
                <span className="font-medium">Découvrir toutes mes apps</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M13.5 4.5h6v6h-2.25V8.31l-7.22 7.22-1.56-1.56 7.22-7.22H13.5V4.5z" />
                  <path d="M19.5 19.5h-15v-15H12V3H3a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 3 21h15a1.5 1.5 0 0 0 1.5-1.5v-9H19.5v9z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Texture douce */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(1000px_500px_at_50%_-10%,rgba(59,130,246,0.15),transparent)]"
        />

        {/* Liens légaux (facultatif) */}
        <div className="border-t border-white/10">
          <div className="mx-auto max-w-7xl px-6 py-4">
            <nav className="flex flex-wrap items-center justify-center gap-4 text-xs text-white/60">
              <a href="/mentions-legales" className="hover:text-white">
                Mentions légales
              </a>
              <span aria-hidden="true">•</span>
              <a href="/politique-confidentialite" className="hover:text-white">
                Politique de confidentialité
              </a>
              <span aria-hidden="true">•</span>
              <a href="/conditions-utilisation" className="hover:text-white">
                Conditions d’utilisation
              </a>
            </nav>
          </div>
        </div>
      </footer>

      {/* Barre tout en bas */}
      <aside className="w-full bg-black text-white/80 text-center text-sm py-3">
        <p>
          © {new Date().getFullYear()} — Tous droits réservés —{" "}
          <a
            href="https://www.monappliclub.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-white"
          >
            MonAppliClub
          </a>{" "}
          • Laurent Victorin
        </p>
      </aside>
    </div>
  );
};

export default Footer;
